import { questionMappings } from "../enrollmentForm/utils";

export const courseToProgramId = {
  OR: 1,
  eOR: 2,
  TP1: [4, 5, 6],
  TP2: [13],
  TT: 14,
};

export const courseToGroup = (course) => {
  return courseToProgramId[course];
};

export const extractGroupsPerApplication = (data) => {
  return data.map((item) => {
    const expectedProgramId = courseToProgramId[item?.course];
    const matchingGroup = item.groups.find((group) =>
      Array.isArray(expectedProgramId)
        ? expectedProgramId.includes(group.programId)
        : group.programId === expectedProgramId
    );
    return {
      applicationId: item.id,
      group: matchingGroup || null,
    };
  });
};
export function formatData(rawData) {
  return rawData?.reduce(
    (grouped, item) => {
      const application = JSON.parse(item.application);
      const course = item.course;
      const questionMap = questionMappings[course] || {};
      const formattedApplication = Object.entries(application).reduce(
        (acc, [key, value]) => {
          if (value === "" || value === false || value == null) return acc;
          const question = questionMap[key] || key;
          acc[question] = value;
          return acc;
        },
        {}
      );

      const formatted = {
        imeIPrezime: `${item.User.firstName} ${item.User.lastName}`,
        gradPrograma: item.User.programCity || null,
        drzava: item.User.country || null,
        email: item.User.emailAddress || null,
        strucnaSprema: item.User.qualification || null,
        mjestoStanovanja: item.User.city || null,
        grupa: item?.validGroup?.name,
        evaluacijaVoditelja:
          item?.isMentorAccepted === true
            ? "Odobreno"
            : item?.isMentorAccepted === false
              ? "Neodobreno"
              : "Neocijenjeno",
        statusGrupe:
          item?.validGroup?.isArchived === false
            ? "Nije arhivirana"
            : item?.validGroup?.isArchived === true
              ? "Arhivirana"
              : "Nema statusa",
        statusAplikacije:
          item?.isReferadaAccepted === true
            ? "Odobreno"
            : item?.isReferadaAccepted === false
              ? "Neodobreno"
              : "Neocijenjeno",
        komentarMentor: item?.mentorReview || "Nema komentara",
        ...formattedApplication,
      };

      const groupKey =
        course === "OR" ||
        course === "eOR" ||
        course === "TP1" ||
        course === "TP2" ||
        course === "TT"
          ? course
          : "OTHER";
      grouped[groupKey].push(formatted);

      return grouped;
    },
    {
      OR: [],
      eOR: [],
      TP1: [],
      TP2: [],
      TT: [],
      OTHER: [],
    }
  );
}
